import React, { useState } from "react";
import { Tabs, Button, Row, Col, Badge, Modal, Typography, List, Table } from "antd";
import useFetchApiData from "../helper/useFetchApiData";

const { Title, Text } = Typography;

const OrdersTab = () => {
  const orders = useFetchApiData("/customer/order/list");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const showOrderDetails = (order) => {
    setSelectedOrder(order);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedOrder(null);
  };

  const renderOrderRow = (order) => (
    <List.Item
      key={order.id}
      style={{
        margin: "8px 0",
        padding: "12px 16px",
        borderRadius: "8px",
        background: "#fff",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        transition: "transform 0.2s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <Row gutter={[16, 16]} align="middle" style={{ width: "100%" }}>
        <Col xs={24} sm={6}>
          <Text strong>Order ID:</Text> <Text>{order.id}</Text>
          <br />
          <Text type="secondary">{order.date}</Text>
        </Col>
        <Col xs={24} sm={6}>
          <Text type="secondary">Items: {order.total_quantity}</Text>
        </Col>
        <Col xs={24} sm={6}>
          <Badge
            count={order.order_status.toUpperCase()}
            style={{
              backgroundColor: order.order_status === "delivered" ? "#52c41a" : "#ff4d4f",
              color: "#fff",
              padding: "0 8px",
              borderRadius: "12px",
            }}
          />
        </Col>
        <Col xs={24} sm={6} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            size="small"
            style={{ borderRadius: "12px", marginBottom: 8 }}
            onClick={() => showOrderDetails(order)}
          >
            View Details
          </Button>
          <br />
          {order.order_status === "delivered" ? (
             <></>
          ) : (
             <></>
          )}
        </Col>
      </Row>
    </List.Item>
  );

  const deliveredOrders = orders.filter((order) => order.order_status === "delivered");
  const ongoingOrders = orders.filter((order) => order.order_status !== "delivered");

  const productColumns = [
    {
      title: "Product Name",
      dataIndex: "product_details",
      key: "name",
      render: (details) => JSON.parse(details).name,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (price) => `NRS ${price}`,
    },
  ];

  return (
    <div style={{ padding: "16px" }}>
      <Tabs defaultActiveKey="1" type="card" size="large">
        <Tabs.TabPane tab="Ongoing" key="1">
          {ongoingOrders.length > 0 ? (
            <List
              dataSource={ongoingOrders}
              renderItem={renderOrderRow}
              bordered
              style={{ background: "#fafafa", borderRadius: "8px", padding: "8px" }}
            />
          ) : (
            <Text type="secondary">No ongoing orders found.</Text>
          )}
        </Tabs.TabPane>
        <Tabs.TabPane tab="History" key="2">
          {deliveredOrders.length > 0 ? (
            <List
              dataSource={deliveredOrders}
              renderItem={renderOrderRow}
              bordered
              style={{ background: "#fafafa", borderRadius: "8px", padding: "8px" }}
            />
          ) : (
            <Text type="secondary">No order history found.</Text>
          )}
        </Tabs.TabPane>
      </Tabs>

      <Modal
        title={<Title level={4}>Order Details</Title>}
        visible={isModalVisible}
        onCancel={handleModalClose}
        footer={
          <Button type="primary" onClick={handleModalClose}>
            Close
          </Button>
        }
      >
        {selectedOrder && (
          <div>
            <Text strong>Order ID: </Text>
            <Text>{selectedOrder.id}</Text>
            <br />
            <Text strong>Date: </Text>
            <Text>{selectedOrder.created_at}</Text>
            <br />
            <Text strong>Status: </Text>
            <Badge
              count={selectedOrder.order_status.toUpperCase()}
              style={{
                backgroundColor:
                  selectedOrder.order_status === "delivered" ? "#52c41a" : "#ff4d4f",
                color: "#fff",
              }}
            />
            <Title level={5} style={{ marginTop: 16 }}>
              Products Ordered
            </Title>
            <Table
              dataSource={selectedOrder.details}
              columns={productColumns}
              rowKey={(record) => record.id || record.product_id}
              pagination={false}
              bordered
              style={{ marginTop: 16 }}
            />
            <Title level={5} style={{ marginTop: 16 }}>
              Total Price: NRS {selectedOrder.order_amount}
            </Title>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default OrdersTab;
